import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const SocketIntegration = React.lazy(() => import("./SocketIntegration"));

interface SocketIntegrationLazyPropsType {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function SocketIntegrationLazy(props: SocketIntegrationLazyPropsType) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <SocketIntegration {...props} />
    </Suspense>
  );
}
